export const EVENT_THRESHOLD = 250;
export const now = () => new Date().getTime();
export const seconds = ms => ms * 1000;
export const nextEventLoop   = fn => setTimeout(fn, 0);

export const expiringAction = (action = '', timeout = 3000) => {
  let resolver, reject, timeoutID;

  const promise = new Promise((res, rej) => {
    resolver = res;
    reject   = rej;

    timeoutID = setTimeout(() => {
      reject(`timeout - ${action}`);
    }, timeout);
  });

  return { 
    resolve() {
      clearTimeout(timeoutID);
      resolver();
    },
    reject,
    promise
  }
};

export const expiringRequest = (request, timeout) => {
  return expiringAction(`requesting resource ${request}`, timeout);
};

export class ExpiringPromise {
  constructor(fn, timeout, action) {
    const expirer = expiringAction(action, timeout);

    return new Promise((resolve, reject) => {
      expirer.promise.catch(reject);
      fn(resolve, reject);
    });
  }
}

export class Throttler {
  constructor(threshold = EVENT_THRESHOLD) {
    this.threshold = threshold;
    this.lastRun   = now();
  }

  get canRun() {
    const elapsed = now() - this.lastRun;
      
    if(elapsed >= this.threshold) {
      this.lastRun = now();
      return true;
    } else {
      return false;
    }
  }
}

export const getThrottler = threshold => new Throttler(threshold);



// WEBPACK FOOTER //
// ./src/Services/Misc/timing.js